/**
 * API клиент для работы с заказами.
 */
import axios from 'axios';

// Base URL для API
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/orders/api';

const client = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  // Отключаем отправку credentials (cookies), так как endpoints exempt от CSRF
  withCredentials: false,
});

/**
 * Получить заказ по UID.
 * @param {string} uid - UID заказа
 * @returns {Promise<Object>} Данные заказа
 */
export async function getOrderByUid(uid) {
  const response = await client.get(`/admin/${uid}/`);
  return response.data;
}

/**
 * Подтвердить заказ.
 * @param {string} uid - UID заказа
 * @returns {Promise<Object>} Обновлённый заказ
 */
export async function confirmOrder(uid) {
  const response = await client.post(`/admin/${uid}/confirm/`);
  return response.data;
}

/**
 * Отменить заказ с возвратом средств.
 * @param {string} uid - UID заказа
 * @param {string} reason - Причина отмены
 * @param {string} role - Роль ('admin' или 'client')
 * @returns {Promise<Object>} Обновлённый заказ
 */
export async function cancelOrder(uid, reason = '', role = 'admin') {
  const response = await client.post(`/admin/${uid}/cancel/`, { reason, role });
  return response.data;
}

export default client;
